import { hasFeature } from '@/services/featureService';
import { isBillingTeamSupervisor, isInAnyTeam, isSupervisor } from '@/services/userService';
import { useUserStore } from '@/stores/user';
import { Navigate } from 'react-router-dom';
import { hasRoleAccess } from '@/lib/roles';

interface ProtectedRouteProps {
  element: React.ReactElement;
  roles: string[];
  teamKeys?: string[];
  requiredFeature?: string;
  allowSupervisor?: boolean;
  allowBillingSupervisor?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  element,
  roles,
  teamKeys,
  requiredFeature,
  allowSupervisor,
  allowBillingSupervisor,
}) => {
  const userStore = useUserStore((state) => state.user);
  const userRole = userStore?.roleId;

  if (!userStore) return <Navigate to="/login" />;

  // hasRoleAccess treats Tech Support as admin-like only for routes that list 'ADMIN',
  // rather than granting blanket access to every protected route.
  const canAccessByRole =
    hasRoleAccess(userRole, roles) ||
    (!!teamKeys?.length && isInAnyTeam(userStore, teamKeys)) ||
    (!!allowSupervisor && isSupervisor(userStore)) ||
    (!!allowBillingSupervisor && isBillingTeamSupervisor(userStore));

  if (!canAccessByRole) {
    return <Navigate to="/not-found" />;
  }

  if (requiredFeature && !hasFeature(requiredFeature)) {
    return <Navigate to="/not-found" />;
  }

  return element;
};
